<template><span></span></template>
<script>

export default {
    mounted () {
        let style = document.createElement('style')
        style.innerHTML = this.$slots.default[0].text
        document.body.appendChild(style)
    },
}
</script>
